import { useTranslation } from 'react-i18next';
import { ChaosLogo } from '../shared/icons';
import styles from './Header.module.scss';
import { LanguageSwitcher } from './LanguageSwitcher';

export function Header() {
  const { t } = useTranslation();
  return (
    <header className={styles.header}>
      <a
        className={styles.logoBtn}
        href={window.PRICING_PAGE}
        aria-label={t('Go to pricing')}
      >
        <span className={styles.logoTile}>
          <ChaosLogo className={styles.logo} />
        </span>
      </a>
      <nav className={styles.nav}>
        <LanguageSwitcher />
      </nav>
    </header>
  );
}
